import React from 'react';
import { Check, X } from 'lucide-react';

const rows = [
  { feature: 'E-commerce specialised', us: 'Yes — VPOB/APOB only', them: 'Serve all businesses (higher red flag risk)' },
  { feature: 'Marketplace partners', us: 'Amazon SPN, Flipkart, Meesho, JioMart', them: 'None' },
  { feature: 'Starting price', us: '₹799/year (all inclusive)', them: '₹12,000+ (extras for GST filing & APOB)' },
  { feature: 'Documentation', us: 'Registered / notarised agreements', them: 'Plain stamp paper (not compliant)' },
  { feature: 'GST filing + APOB', us: 'Included at no extra cost', them: 'Charged separately' },
  { feature: 'Department representation', us: 'In-house team, locally deployed', them: 'Zero support' },
  { feature: 'GST cancellation rate', us: '<1%', them: '~20%' },
  { feature: 'First-attempt approval', us: '96%', them: '~60%' },
  { feature: 'Refund policy', us: '100% refund after 3 attempts', them: '20% deduction' },
];

const Comparison = () => (
  <section className="bg-[#FAF2E8] py-16 md:py-20" data-testid="comparison-table">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <div className="max-w-2xl">
        <div className="text-xs uppercase tracking-wider text-[#F39200] font-semibold mb-3">Comparison</div>
        <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900 leading-[1.1]">
          EasyWorks{' '}
          <span className="relative inline-block text-[#F39200]">vs Others
            <svg className="absolute -bottom-2 left-0 w-full" height="10" viewBox="0 0 160 10" fill="none">
              <path d="M2 7 C 50 1, 110 1, 158 6" stroke="#F39200" strokeWidth="2" strokeLinecap="round" fill="none" />
            </svg>
          </span>
        </h2>
        <p className="mt-4 text-[15px] text-neutral-600 max-w-xl">
          Why 28,000+ ecommerce sellers pick EasyWorks over generic VPOB providers.
        </p>
      </div>

      <div className="mt-10 rounded-2xl overflow-hidden border border-black/5 bg-white shadow-sm">
        {/* desktop grid */}
        <div className="hidden md:grid grid-cols-[1.2fr_1fr_1fr] text-sm">
          <div className="p-5 font-semibold text-neutral-500 uppercase tracking-wide text-xs bg-neutral-50">Feature</div>
          <div className="p-5 font-semibold bg-[#F39200] text-white text-center flex items-center justify-center gap-2">
            <span className="font-extrabold" style={{ letterSpacing: '-0.02em' }}>easy<span className="text-neutral-900">works</span></span>
          </div>
          <div className="p-5 font-semibold text-neutral-700 text-center bg-neutral-100">Other providers</div>

          {rows.map((r, i) => (
            <React.Fragment key={r.feature}>
              <div className={`p-5 font-medium text-neutral-900 ${i % 2 === 0 ? 'bg-white' : 'bg-neutral-50/60'}`}>{r.feature}</div>
              <div className={`p-5 text-sm text-neutral-800 flex items-start gap-2 border-l border-black/5 ${i % 2 === 0 ? 'bg-[#F39200]/[0.06]' : 'bg-[#F39200]/[0.03]'}`}>
                <Check size={16} className="text-emerald-600 mt-0.5 shrink-0" />
                <span>{r.us}</span>
              </div>
              <div className={`p-5 text-sm text-neutral-600 flex items-start gap-2 border-l border-black/5 ${i % 2 === 0 ? 'bg-white' : 'bg-neutral-50/60'}`}>
                <X size={16} className="text-neutral-400 mt-0.5 shrink-0" />
                <span>{r.them}</span>
              </div>
            </React.Fragment>
          ))}
        </div>

        {/* mobile stacked */}
        <div className="md:hidden divide-y divide-black/5">
          {rows.map((r) => (
            <div key={r.feature} className="p-4">
              <div className="text-xs font-semibold uppercase tracking-wide text-neutral-500">{r.feature}</div>
              <div className="mt-3 flex items-start gap-2 bg-[#F39200]/[0.06] rounded-lg p-3">
                <Check size={16} className="text-emerald-600 mt-0.5 shrink-0" />
                <div><div className="text-[11px] font-semibold text-[#F39200]">EasyWorks</div><div className="text-sm text-neutral-800">{r.us}</div></div>
              </div>
              <div className="mt-2 flex items-start gap-2 bg-neutral-50 rounded-lg p-3">
                <X size={16} className="text-neutral-400 mt-0.5 shrink-0" />
                <div><div className="text-[11px] font-semibold text-neutral-500">Others</div><div className="text-sm text-neutral-600">{r.them}</div></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Comparison;
